import { QueryParamsModel } from '../../../_base/crud/models/query-models/query-params.model';
import { forkJoin } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { mergeMap, map, tap, delay } from 'rxjs/operators';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../../_base/crud';
// Services
import { InvoiceService } from '../_services/invoice.service';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';
// State
import { AppState } from '../../../../core/reducers';
// Actions
import {
    InvoiceActionTypes,
    InvoicePageRequested,
    InvoicePageLoaded,
    OneInvoiceDeleted,
    InvoiceActionToggleLoading,
    InvoicePageToggleLoading,
    InvoiceUpdated,
    InvoiceCreated,
    InvoiceOnServerCreated
} from '../_actions/invoice.actions';
import { of } from 'rxjs';

@Injectable()
export class InvoiceEffects {
    showPageLoadingDistpatcher = new InvoicePageToggleLoading({ isLoading: true });
    showActionLoadingDistpatcher = new InvoiceActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new InvoiceActionToggleLoading({ isLoading: false });

    @Effect()
    loadInvoicePage$ = this.actions$.pipe(
        ofType<InvoicePageRequested>(InvoiceActionTypes.InvoicePageRequested),
        mergeMap(({ payload }) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.invoiceService.findInvoices(payload.page);
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];
            const lastQuery: QueryParamsModel = response[1];

            this.sharedService.updateInvoiceList(result.items);
            //console.log(result.items);
            const pageLoadedDispatch = new InvoicePageLoaded({
                invoices: result.items,
                totalCount: result.totalCount,
                page: lastQuery
            });
            return pageLoadedDispatch;
        })
    );

    @Effect()
    deleteInvoice$ = this.actions$
        .pipe(
            ofType<OneInvoiceDeleted>(InvoiceActionTypes.OneInvoiceDeleted),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.invoiceService.deleteInvoice(payload.InvoiceId);
            }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    @Effect()
    updateInvoice$ = this.actions$
        .pipe(
            ofType<InvoiceUpdated>(InvoiceActionTypes.InvoiceUpdated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.invoiceService.updateInvoice(payload.invoice.InvoiceId, payload.invoice);
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            })
        );

    @Effect()
    createInvoice$ = this.actions$
        .pipe(
            ofType<InvoiceOnServerCreated>(InvoiceActionTypes.InvoiceOnServerCreated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.invoiceService.createInvoice(payload.invoice).pipe(
                    tap(res => {
                        //console.log(res);
                        //const resValue = Object.keys(res).map(key => res[key]);
                        //console.log(resValue[0].value);
                        //this.store.dispatch(new InvoiceCreated({ invoice: res }));
                        if (res.InvoiceId == 0) {
                            this.store.dispatch(new InvoiceCreated({ invoice: res }));
                        } else {
                            console.log('There is somthing wrong');
                            //this.store.dispatch(new InvoiceErrorMessage({ _errorMessage: resValue[0].value }));
                        }

                    })
                );
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    constructor(private actions$: Actions, private invoiceService: InvoiceService,
        private sharedService: ShareddataserviceService, private store: Store<AppState>) { }
}
